import React from "react";
import axios from "axios";
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faPencil,
  faTrash,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";

import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ExportToCsv } from "export-to-csv"; //or use your library of choice here

import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { setYear } from "date-fns/esm";

const SeedDistribution = () => {
  const navigate = useNavigate();
  const [value, setvalue] = useState("");
  const [flag, setFlag] = useState(false);
  const [schemeData, setSchemeData] = useState([]);
  const [schemeValue, setSchemeValue] = useState("");
  const [deleteCode, setDeleteCode] = useState({});
  const [editCode, setEditCode] = useState("");
  const [stateValue, setStateValue] = useState("");
  const [districtValue, setDistrictValue] = useState("");
  // const [iuLevelValue, setiuLevelValue] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [cropValue, setCropValue] = useState("");

  const [iuLevelData, setiuLevelData] = useState([]);
  const [formsData, setFormsData] = useState([]);
  const [statesData, setStatesData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  let [optionsState, setOptionsState] = useState([]);
  const [selected, setSelected] = useState([]);
  const [seasonValue, setSeasonValue] = useState("");
  const [seasonData, setSeasonData] = useState([]);
  const [yearValue, setYearValue] = useState("");
  const [yearData, setYearData] = useState([])

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const result = await axios(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/NFSM/SeedDistribution`
    );
    setSchemeData(result.data.dataContent);
  };

  useEffect(() => {
    if (flag == true) {
      fetchData();
    }
  }, [flag]);

  const columns = useMemo(
    () => [
      {
        header: "S.No",
        Cell: (cell) => Number(cell.row.id) + 1,
      },
      {
        accessorKey: "stateName",
        header: "State Name ",
      },
      {
        accessorKey: "districtName",
        header: "District Name ",
      },
      {
        accessorKey: "farmerName",
        header: "Farmer Name ",
      },
      {
        accessorKey: "seasonName",
        header: "Season Name",
      },
      {
        accessorKey: "demonstration",
        header: "Demonstration",
      }, 
      {
        accessorKey: "demonstrationType",
        header: "Demonstration Type",
      }, 
      {
        accessorKey: "sourceOfIrrigation",
        header: "Source Of Irrigation",
      },

      {
        accessor: "",
        header: "Actions",
        Cell: (cell) => (
          <>
            <i
              className="btn text-success"
              type="button"
              onClick={() =>
                navigate("/nfsm/singleSeedDistributionview", {
                  state: { SeedDistributionCode: cell.row.original },
                })
              }
            >
              {" "}
              <FontAwesomeIcon icon={faEye} />
            </i>
          </>
        ),
      },
    ],
    []
  );

  function handleState() {}

  async function handleFilter() {
    let newStartDate;
    let newEndDate;
    if (startDate) {
      let formatStartDate = startDate.split("-");
      newStartDate =
        formatStartDate[2] +
        "/" +
        formatStartDate[1] +
        "/" +
        formatStartDate[0];
    } else {
      newStartDate = false;
    }

    if (endDate) {
      let formatEndDate = endDate.split("-");
      newEndDate =
        formatEndDate[2] + "/" + formatEndDate[1] + "/" + formatEndDate[0];
    } else {
      newEndDate = false;
    }

    const result = await axios.post(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/Nature/TranCropSurvey/getCropSurveyListbyFilter`,
      {
        cropSurveyCode: 0,
        mobileNo: "",
        stateCode: stateValue ? stateValue : 0,
        districtCode: districtValue ? districtValue : 0,
        blockCode: 0,
        gramPanchayatCode: 0,
        villageCode: 0,
        lokSabhaCode: 0,
        surveyorID: "",
        seasonCode: seasonValue ? seasonValue : 0,
        financialYear: yearValue ? String(yearValue) : "",
        cropCode: 0,
        surveyDateFrom: newStartDate ? String(newStartDate) : "",
        surveyDateTo: newEndDate ? String(newEndDate) : "",
      }
    );
    setSchemeData(result.data.dataContent);
  }

  function handleClearFilter() {
    setStateValue("");
    setDistrictValue("");
    setSeasonValue("");
    setYearValue("");
    setStartDate("");
    setEndDate("");
    document.getElementById("startDate").value = "";
    document.getElementById("endDate").value = "";
    // document.getElementById("findBtn").disabled = false;
    fetchData();
  }

  function getStates() {
    const fetchStates = async () => {
      const result = await axios(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/states`
      );
      setStatesData(result.data.dataContent);
    };
    fetchStates();
  }

  function getYears() {
    const fetchYear = async () => {
      const result = await axios("http://naturalfarming.dac.gov.in/NFservices/api/NFFinancialYear");
      setYearData(result.data.Response);
    };
    fetchYear();
  }

  function getSeason() {
    const fetchSeason = async () => {
      const result = await axios(
        "http://naturalfarming.dac.gov.in/NFservices/api/NaturalFarmingCropSeason"
      );
      setSeasonData(result.data.Response);
    };
    fetchSeason();
  }

  function handleState(value) {
    if (value === "NA") {
      return;
    }
    setStateValue(value);
    setDistrictData([]);

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      stateCode: Number(value),
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/district`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setDistrictData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }

  // Below Code is use to download table data as CSV



  const handleExportRows = (rows) => {
    const csvOptions = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: false,
      headers: Object.keys(schemeData[0]),
    };
    
    const csvExporter = new ExportToCsv(csvOptions);
    csvExporter.generateCsv(rows.map((row) => row.original));
  };

  const handleExportData = () => {
    const csvOptions2 = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: false,
      headers: Object.keys(schemeData[0]),
    };
    
    const csvExporter2 = new ExportToCsv(csvOptions2);
    csvExporter2.generateCsv(schemeData);
  };

  return (
    <>

      <main id="main" className="main">
        <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
          <nav>
            <h1>Seed Distribution</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">Admin</li>
              <li className="breadcrumb-item">NFSM</li>
              <li className="breadcrumb-item active">Seed Distribution</li>
            </ol>
          </nav>
        </div>
        <section className="section">
          <div className="row justify-content-lg-center">
            <div className="col-lg-12 ">
              <div className="card">
                <div className="card-body">
                  <form className="row g-3">
                    <div className="col-md-2">
                      <label htmlFor="State" className="form-label">
                        State
                      </label>
                      <select
                        id="State"
                        required
                        className="form-select"
                        onClick={getStates}
                        onChange={(e) => handleState(e.target.value)}
                        value={stateValue}
                      >
                        <option defaultValue value="NA">
                          Choose...
                        </option>
                        {statesData.map((item, id) => {
                          return (
                            <option key={id} value={item.stateCode}>
                              {" "}
                              {item.stateName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="District" className="form-label">
                        District
                      </label>
                      <select
                        id="District"
                        className="form-select"
                        onChange={(e) => setDistrictValue(e.target.value)}
                        value={districtValue}
                      >
                        <option defaultValue value="NA">
                          Choose...
                        </option>

                        {districtData.map((item, id) => {
                          return (
                            <option key={id} value={item.districtCode}>
                              {" "}
                              {item.districtName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="Season" className="form-label">
                        Season
                      </label>
                      <select
                        id="Season"
                        className="form-select"
                        onClick={getSeason}
                        onChange={(e) => setSeasonValue(e.target.value)}
                        value={seasonValue}
                      >
                        <option defaultValue>Choose...</option>

                        {seasonData.map((item, id) => {
                          return (
                            <option key={id} value={item.SeasonID}>
                              {" "}
                              {item.SeasonName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="startdate" className="form-label">
                        Start Date
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="startDate"
                        max={endDate}
                        onChange={(e) => setStartDate(e.target.value)}
                      />
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="enddate" className="form-label">
                        End Date
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="endDate"
                        min={startDate}
                        onChange={(e) => setEndDate(e.target.value)}
                      />
                    </div>

   
                    <div className="col-md-2">
                      <label htmlFor="Year" className="form-label">
                        Year
                      </label>
                      <select
                        id="Year"
                        className="form-select"
                        onClick={getYears}
                        onChange={(e) => setYearValue(e.target.value)}
                        value={yearValue}
                      >
                      <option defaultValue value="NA">
                          Choose...
                        </option>
                        {yearData.map((item, id) => {
                          return (
                            <option key={id} value={item.YearId}>
                              {" "}
                              {item.LandYear}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="col-md-12 d-flex justify-content-md-center">
                      <button
                        type="button"
                        className="btn btn-primary me-md-2"
                        onClick={handleFilter}
                        id="findBtn"
                      >
                        Find
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary me-md-2"
                        onClick={handleClearFilter}
                        id="clearBtn"
                      >
                        Clear
                      </button>
                    </div>
                  </form>
                </div>
              </div>

              <div className="card">
                <MaterialReactTable
                  columns={columns}
                  data={schemeData}
                  enableColumnOrdering
                  enablePagination={true}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                      }}
                    >
                      <Button
                        color="primary"
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        onClick={handleExportData}
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export All Data
                      </Button>
                      <Button
                        disabled={
                          table.getPrePaginationRowModel().rows.length === 0
                        }
                        //export all rows, including from the next page, (still respects filtering and sorting)
                        onClick={() =>
                          handleExportRows(
                            table.getPrePaginationRowModel().rows
                          )
                        }
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export Filter Data
                      </Button>
                    </Box>
                  )}
                />
              </div>
            </div>
          </div>
        </section>
      </main>
    
    </>
  );
};

export default SeedDistribution;
